export const errorCodes = {
    unauthenticated: 'AUTH_REQUIRED',
    permissionDenied: 'PERMISSION_DENIED',
    inactiveUser: 'INACTIVE_USER',
    invalidInput: 'INVALID_INPUT',
    duplicatePatient: 'DUPLICATE_PATIENT',
    scheduleConflict: 'SCHEDULE_CONFLICT',
    holidayBlocked: 'HOLIDAY_BLOCKED',
    invalidTransition: 'INVALID_TRANSITION',
    refundExceedsPayments: 'REFUND_EXCEEDS_PAYMENTS',
    idempotencyMismatch: 'IDEMPOTENCY_MISMATCH',
    searchUnavailable: 'SEARCH_UNAVAILABLE',
    attachmentRejected: 'ATTACHMENT_REJECTED',
    unavailable: 'UNAVAILABLE',
};
export const userFacingErrorMessage = {
    AUTH_REQUIRED: 'Entre novamente para continuar.',
    PERMISSION_DENIED: 'Você não tem permissão para realizar esta ação.',
    INACTIVE_USER: 'Seu acesso está inativo. Fale com a administração da clínica.',
    INVALID_INPUT: 'Revise os campos informados e tente novamente.',
    DUPLICATE_PATIENT: 'Já existe um paciente cadastrado com este CPF.',
    SCHEDULE_CONFLICT: 'Este horário acabou de ser ocupado. Atualize a agenda e escolha outro horário.',
    HOLIDAY_BLOCKED: 'A agenda fica bloqueada automaticamente nos feriados.',
    INVALID_TRANSITION: 'Esta alteração não está disponível para o estado atual da consulta.',
    REFUND_EXCEEDS_PAYMENTS: 'O valor devolvido não pode ultrapassar o total recebido.',
    IDEMPOTENCY_MISMATCH: 'Não foi possível repetir esta operação com dados diferentes.',
    SEARCH_UNAVAILABLE: 'A busca está temporariamente indisponível. Tente novamente em instantes.',
    ATTACHMENT_REJECTED: 'Envie uma imagem ou PDF dentro do limite permitido.',
    UNAVAILABLE: 'Não foi possível concluir a ação agora. Tente novamente.',
};
//# sourceMappingURL=errors.js.map